<template>
<div>
      <b-form v-if="!previewVideo" @submit.prevent="onSubmit" @reset.prevent="onReset">
        <!-- TITRE -->
        <b-form-group v-if="(form.type==='live' || form.type==='vod' && fileOrUrl=='url')" id="vodGroup1"
                      label="Title:"
                      label-for="vodInput1"
                      >
          <b-form-input id="vodInput1"
                        type="text"
                        v-model="form.title"
                        required
                        size="sm"
                        placeholder="Enter title">
          </b-form-input>
        </b-form-group>

        <!-- ACTUAL FILE/URL -->
        <b-form-group v-if="(form.type==='vod' && fileOrUrl=='file')" id="vodUploadGroup"
                      label="File(s) to upload:"
                      label-for="vodFile">
          <b-row v-cloak @drop.prevent="isDraghover = false; addFile($event)">
            <b-col cols="12"  :class="{draggable:true, draghover: isDraghover}"  @dragover.prevent="isDraghover = true" @dragenter.prevent="isDraghover = true" @dragleave.prevent="isDraghover = false" @dragend.prevent="isDraghover = false" >
              <b-row class="justify-content-center" v-if="files.length === 0">
                <b-col cols="6"><font-awesome-icon class="uploadlogo" icon="cloud-upload-alt"></font-awesome-icon></b-col>
              </b-row>
              <b-row class="justify-content-center" v-if="files.length === 0">
                <h6 class="uploadtext">Drag and drop files here or click the + button below</h6>
              </b-row>
              <b-row class="inputCard justify-content-center align-items-center" style="line-height=0px" v-for="(file2, fileIndex2) in files" v-bind:key="file2.filename"> 
                <font-awesome-icon class="filelogo" icon="film"></font-awesome-icon>
                <p style="padding: 0px 10px; margin:0px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap"><strong>{{file2.name}}</strong></p>
                <p style="padding: 0px 10px; margin:0px; text-align:center; border-left: 0.2rem solid #2a5d77">Size: {{Math.round(file2.size / 1000000)}} MB</p>
                <b-button variant="emptyB" v-if="!uploadStarted" @click="selectedFile=file2; qualitiesModal=file2.qualities, showModal('qualities')">
                  <b-img v-if="file2.encoding === 'encoding' && file2.qualities.length === 0" fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" title="QUANTEEC algorithm"/>
                  <span v-if="file2.encoding === 'passthrough'" title="Passthrough mode (as original, no additional quality)">
                    <strong>P</strong>
                  </span>
                  <span v-if="file2.encoding === 'encoding' && file2.qualities.length > 0" :title="'Custom encoding in '+file2.qualities.length+' qualities'">
                    <strong>C </strong>{{file2.qualities.length}}Q
                  </span> 
                </b-button>
                <b-button variant="emptyB" v-else disabled>
                  <b-img v-if="file2.encoding === 'encoding' && file2.qualities.length === 0" fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" title="QUANTEEC algorithm" />
                  <span v-if="file2.encoding === 'passthrough'" title="Passthrough mode (as original, no additional quality)">
                    <strong>P</strong>
                  </span>
                  <span v-if="file2.encoding === 'encoding' && file2.qualities.length > 0" :title="'Custom encoding in '+file2.qualities.length+' qualities'">
                    <strong>C </strong>{{file2.qualities.length}}Q
                  </span> 
                </b-button>

                <b-button v-if="!uploadStarted" variant="emptyB" @click="removeFile(fileIndex2)" >
                  <font-awesome-icon style="color: red" :icon="['fas', 'trash']" />
                </b-button>
                <b-button v-if="uploadStarted && !file2.toCancel" variant="emptyB" @click="cancelUpload(fileIndex2)" >
                  <font-awesome-icon style="color: red" :icon="['fas', 'trash']" />
                </b-button>
                <b-col cols=12 ><p v-if="file2.isLoading && !file2.toCancel" style="text-align:center; padding-top:10px; color:#14BF98">Upload in progress...</p></b-col>
                <b-col cols=12 ><p v-if="file2.isLoadingEnd && !file2.toCancel" style="text-align:center; padding-top:10px; color:#2F90B0">Video uploaded.</p></b-col>
                <b-col cols=12 ><p v-if="file2.toCancel" style="text-align:center; padding-top:10px; color:red">Cancelling upload.</p></b-col>

                <b-progress style="width:100%" v-if="file2.isLoading || file2.isLoadingEnd">
                  <b-progress-bar :value="file2.loadingPercent" animated variant="primary">
                    {{file2.loadingPercent}}%
                  </b-progress-bar>
                </b-progress>
              </b-row>
              <b-row class="justify-content-center" v-if="!uploadStarted">
                <b-col cols="auto">
                  <label for="file-upload" class="custom-file-upload">
                    <div class="btn btn-darkblue" style="width: 50px; margin:10px; font-weight:bold">+</div>
                  </label>
                  <input id="file-upload" accept="video/*" @input="addFile($event)" type="file" multiple style="display: none;"/>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form-group>

        <!-- LIVE -->
        <div v-if="(form.type==='live')" style="border-bottom:1px solid #2a5d77; margin:10px 150px"></div>

        <b-form-group v-if="(form.type==='live')" id="liveGroup1" style="margin-bottom: 0px">
          <b-form-group id="vodckeck" label="Live stream origin:" label-for="livestreamCheck">
            <b-row class="justify-content-around">
              <b-col lg="4" md="4" sm="6" cols="10">
                <b-row class="justify-content-center align-items-center commonChoice2" @click="urlAuto = 'simple'" v-bind:class="{'selectedChoice2': urlAuto === 'simple', 'unselectedChoice2': urlAuto !== 'simple'}">
                  <small style="line-height:normal">
                    <b-img fluid :src="require(`@/assets/webcam.png`)" style="max-height:15px" />
                    Camera / Screen capture
                  </small>
                </b-row>
              </b-col>
              <b-col lg="4" md="4" sm="6" cols="10">
                <b-row class="justify-content-center align-items-center commonChoice2" @click="urlAuto = 'auto'; resetPassword()" v-bind:class="{'selectedChoice2': urlAuto === 'auto', 'unselectedChoice2': urlAuto !== 'auto'}">
                  <small style="line-height:normal">
                    <font-awesome-icon style="color:black" :icon="['fab', 'affiliatetheme']" />
                    Streaming software (e.g., OBS)
                  </small>
                </b-row>
              </b-col>
              <b-col lg="4" md="4" sm="6" cols="10">
                <b-row class="justify-content-center align-items-center commonChoice2" @click="urlAuto = 'url'; resetPassword()" v-bind:class="{'selectedChoice2': urlAuto === 'url', 'unselectedChoice2': urlAuto !== 'url'}">
                  <small style="line-height:normal">
                    <font-awesome-icon style="color:black" :icon="['fas', 'stream']" />
                    Custom stream (RTSP, RTMP, HTTP)
                  </small>
                </b-row>
              </b-col>
            </b-row>
          </b-form-group>

          <b-row class="justify-content-center"> 
            <b-form-input size="sm" style="max-width:500px" v-if="urlAuto === 'url'" id="liveInput1"
                        type="text"
                        v-model="form.url"
                        :required="form.type==='live'"
                        placeholder="Enter URL (rtmp, rtsp or http)">
            </b-form-input>
          </b-row>
          <p style="text-align:center" v-if="urlAuto === 'auto'"><small>Stream information to report on your streaming software: </small></p>
          <p style="text-align:center" v-if="urlAuto === 'auto'">
            <small>
              URL: 
              <span style="color:blue;">
                {{autoUrl}}&nbsp;
                <b-button variant="darkblue" style="font-size:11px; padding:2px 5px" 
                  @click="
                    copyClipAddr();
                    showAndHideModal('confirmCopyClipAddr');
                  "
                  title="Copy to clipboard"
                >
                  <font-awesome-icon icon="clone" />
                  Copy
                </b-button>
              </span>
            </small>
          </p>
          <p style="text-align:center" v-if="urlAuto === 'auto'">
            <small>
              KEY: 
              <span style="color:blue;" >
                <span v-if="isShowKey">{{autoID}}&nbsp;</span>
                <span v-if="!isShowKey">&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&nbsp;</span>
                <b-button
                  tabindex="-1"
                  v-if="!isShowKey"
                  variant="darkblue"
                  @click="isShowKey = !isShowKey"
                  style="font-size:12px; padding:2px 5px"
                  ><font-awesome-icon
                    :icon="['fas', 'eye']"
                  ></font-awesome-icon
                ></b-button>
                <b-button
                  tabindex="-1"
                  v-if="isShowKey"
                  variant="darkblue"
                  @click="isShowKey = !isShowKey"
                  style="font-size:12px; padding:2px 5px"
                  ><font-awesome-icon
                    :icon="['fas', 'eye-slash']"
                  ></font-awesome-icon
                ></b-button>
                &nbsp;
                <b-button variant="darkblue" style="font-size:11px; padding:2px 5px" 
                    @click="
                      copyClipKey();
                      showAndHideModal('confirmCopyClipKey');
                    "
                    title="Copy to clipboard"
                  >
                    <font-awesome-icon icon="clone" />
                    Copy
                  </b-button>
              </span>
            </small>
          </p>
        </b-form-group>

        <b-form-group style="text-align:center" v-if="(form.type==='live') && urlAuto === 'simple'"  id="vodckeck"
                      label="Targeted audience:"
                      label-for="delayCheck">
                <b-row class="justify-content-around">
                     <b-col lg="4" md="4" sm="6" cols="10">
                      <b-row class="justify-content-center align-items-center commonChoice3" @click="form.delay = 'no'; form.seekLive = false" v-bind:class="{'selectedChoice2': form.delay === 'no', 'unselectedChoice2': form.delay !== 'no'}">
                        <small style="line-height:normal">
                          No-delay only (5 viewers max.)
                        </small>
                      </b-row>
                    </b-col>
                    <b-col lg="4" md="4" sm="6" cols="10">
                      <b-row class="justify-content-center align-items-center commonChoice3" @click="form.delay = 'middle'; resetPassword()" v-bind:class="{'selectedChoice2': form.delay === 'middle', 'unselectedChoice2': form.delay !== 'middle'}">
                        <small style="line-height:normal">
                          No-delay for 5 first viewers + low-delay for the others
                        </small>
                      </b-row>
                    </b-col>
                    <b-col lg="4" md="4" sm="6" cols="10">
                      <b-row class="justify-content-center align-items-center commonChoice3" @click="form.delay = 'yes'; resetPassword()" v-bind:class="{'selectedChoice2': form.delay === 'yes', 'unselectedChoice2': form.delay !== 'yes'}">
                        <small style="line-height:normal">
                          Low-delay only (large audience)
                        </small>
                      </b-row>
                    </b-col>
                </b-row>
        </b-form-group>

        <div v-if="(form.type==='live')" style="border-bottom:1px solid #2a5d77; margin:10px 150px"></div>
        <b-form-group label="Parameters:" style="margin-bottom:0px">

          <b-row class="align-items-center">
            <b-col sm="5" cols="12">
              <b-form-group style="margin-bottom:10px">
                <b-form-checkbox size="sm" v-model="isPassword" switch >
                  Protect with a password
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col sm="7" cols="12">
              <b-form-group v-if="isPassword" label-for="passwordLiveInput" >
                <b-input-group>
                  <b-form-input :id="'passwordLiveInput' + new Date().getTime()"
                                :type="passwordType"
                                v-model="myPassword"
                                placeholder="Enter password"
                                size="sm">
                  </b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" tabindex="-1" v-if="passwordType === 'password'" variant="db-sb1" @click="passwordType = 'text'"><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon></b-button>
                    <b-button size="sm" tabindex="-1" v-if="passwordType === 'text'" variant="db-sb1" @click="passwordType = 'password'"><font-awesome-icon :icon="['fas', 'eye-slash']"></font-awesome-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="align-items-center">
            <b-col>
              <b-form-group style="margin-bottom:10px">
                <b-form-checkbox size="sm" id="autoPlay" v-model="form.autoplay" switch >
                  Activate auto-play
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="align-items-center">
            <b-col>
              <b-form-group style="margin-bottom:10px" v-if="form.type === 'live'">
                <b-form-checkbox size="sm" id="keepLive" v-model="form.keepLive" switch :disabled="$auth.getMyUser().client_infos[0].noKeepLive" >
                  Archive automatically the Live stream as VOD files (this will use your storage)
                  <font-awesome-icon id="popoverArc" icon="question-circle"></font-awesome-icon>
                  <b-popover size="sm" target="popoverArc" triggers="hover" placement="top">
                    <template #title ><small>Live to VOD</small></template>
                    <small><b>Archives</b> will be automatically created each time you stop the stream or when no input is received for 1min. There are no restrictions in re-launching the stream, after it is stopped.</small>
                  </b-popover>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="align-items-center">
            <b-col>
              <b-form-group style="margin-bottom:10px" v-if="form.type === 'live' && (urlAuto !== 'simple' || form.delay !== 'no')" >
                <b-form-checkbox size="sm" id="seekLive" v-model="form.seekLive" switch>
                  Authorize to seek back and forth during Live session 
                  <span v-if="form.delay === 'middle'">
                  (only for low-delay viewers)
                  </span>
                </b-form-checkbox>
              </b-form-group>
              <b-form-group v-else-if="form.delay === 'no'" >
                <b-form-checkbox size="sm" id="seekLive" v-model="form.seekLive" disabled switch>
                  Authorize to seek back and forth during Live session (unavailable for no-delay viewers)
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="align-items-center justify-content-center mb-3" v-if="form.type === 'live' && form.keepLive === false && form.seekLive === true && form.delay !== 'no'">
            <small>Number of seconds to keep (min: 30 - max: 600):&nbsp;</small>
            <b-form-input size="sm" type="number"
              v-model="liveToKeepDuration" min="30" style="width:160px"
              placeholder="Saved seconds" max="600" />
          </b-row>

          <b-row class="align-items-center justify-content-center mb-3" v-if="form.type === 'live'" >          
            <b-button size="sm" @click="showModal('qualitiesLive')"  variant="quanteeclg">
              Encoding mode: 
              <b-img 
                v-if="encodingLive === 'encoding' && qualitiesModalLive.length === 0" 
                :src="require(`@/assets/logo.svg`)" 
                style="max-height:20px"
                title="QUANTEEC algorithm" 
              />
              <span v-if="encodingLive === 'passthrough'" title="Same as original, no additional quality">
                <strong>P-Passthrough</strong>
              </span>
              <span v-if="encodingLive === 'encoding' && qualitiesModalLive.length > 0" >
                <strong>C-Custom </strong>({{qualitiesModalLive.length}} qualities)
              </span>

            </b-button>
          </b-row>

        </b-form-group>

        <div v-if="(form.type==='live')" style="border-bottom:1px solid #2a5d77; margin:10px 150px"></div>

        <b-form-group v-if="(form.type==='live')" label="Simulcast to external platforms*:" style="margin-bottom:0px">

          <b-row v-if="form.type === 'live'" class="justify-content-around align-items-center" style="margin-bottom:10px">
            <b-col class="liveBrand">
              <font-awesome-icon id="quanteecYoutube" class="quanteecyoutube" :class="{quanteecyoutubevalide: external_youtube.length > 0}" :icon="['fab', 'youtube']" />
              <b-badge v-if="external_youtube.length > 0" style="font-size:12px; background-color:#FF0000">{{external_youtube.length}}</b-badge>
            </b-col>
            <b-col class="liveBrand">
              <font-awesome-icon id="quanteecFacebook" class="quanteecfacebook" :class="{quanteecfacebookvalide: external_facebook.length > 0}" :icon="['fab', 'facebook']" />
              <b-badge v-if="external_facebook.length > 0" style="font-size:12px; background-color:#4267B2">{{external_facebook.length}}</b-badge>
            </b-col>
            <b-col class="liveBrand">
              <font-awesome-icon id="quanteecTwitch" class="quanteectwitch" :class="{quanteectwitchvalide: external_twitch.length > 0}" :icon="['fab', 'twitch']" />
              <b-badge v-if="external_twitch.length > 0" style="font-size:12px; background-color:#9146FF">{{external_twitch.length}}</b-badge>
            </b-col>
            <b-col class="liveBrand">
              <font-awesome-icon id="quanteecOther" class="quanteecother" :class="{quanteecothervalide: external_other.length > 0}" :icon="['fas', 'video']" />
              <b-badge v-if="external_other.length > 0" style="font-size:12px; background-color:rgb(20, 191, 152)">{{external_other.length}}</b-badge>
            </b-col>

            <b-popover ref="popoverYt" target="quanteecYoutube" triggers="click" placement="top">
              <template #title>
                <b-row class="justify-content-center align-items-center m-2">
                  Stream to YouTube&nbsp;
                  <font-awesome-icon :class="{quanteecyoutubevalide: external_youtube.length > 0}" :icon="['fab', 'youtube']" />
                </b-row>
              </template>

              <b-row class="align-items-center m-1" v-for="(stream,streamid) in external_youtube" v-bind:key="streamid">
                <b-col class="m-0 p-0" cols="11">
                  <b-form-input 
                    size="sm" type="text"
                    v-model="stream.key"
                    :placeholder="'Enter YouTube key '+(streamid+1)">
                  </b-form-input>
                </b-col>
                <b-col class="m-0 p-0" cols="1">
                  <b-button variant="borderedx" v-if="external_youtube.length > 0" size="sm" @click="external_youtube.splice(streamid, 1)">
                    <font-awesome-icon size="sm" style="color:red" icon="times" />
                  </b-button>
                </b-col>
              </b-row>

                <b-row class="justify-content-center mt-3 mb-3">
                  <b-col cols="auto">
                    <b-button variant="msstreamblue" size="sm" @click="$refs['popoverYt'].$emit('close')">
                      Ok
                    </b-button>
                  </b-col>
                  <b-col cols="auto">
                    <b-button variant="mswarning" size="sm" @click="external_youtube.push({key:''})">
                      <b-icon icon="plus-circle" />
                      Add a stream key
                    </b-button>
                  </b-col>
              </b-row>
            </b-popover>
             
            <b-popover ref="popoverFa" target="quanteecFacebook" triggers="click" placement="top">
              <template #title>
                <b-row class="justify-content-center align-items-center m-2">
                  Stream to Facebook&nbsp;
                  <font-awesome-icon :class="{quanteecfacebookvalide: external_facebook.length > 0}" :icon="['fab', 'facebook']" />
                </b-row>
              </template>

              <b-row class="align-items-center m-1" v-for="(stream,streamid) in external_facebook" v-bind:key="streamid">
                <b-col class="m-0 p-0" cols="11">
                  <b-form-input 
                    size="sm" type="text"
                    v-model="stream.key"
                    :placeholder="'Enter Facebook key '+(streamid+1)">
                  </b-form-input>
                </b-col>
                <b-col class="m-0 p-0" cols="1">
                  <b-button variant="borderedx" v-if="external_facebook.length > 0" size="sm" @click="external_facebook.splice(streamid, 1)">
                    <font-awesome-icon size="sm" style="color:red" icon="times" />
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="justify-content-center mt-3 mb-3">
                  <b-col cols="auto">
                    <b-button variant="msstreamblue" size="sm" @click="$refs['popoverFa'].$emit('close')">
                      Ok
                    </b-button>
                  </b-col>
                  <b-col cols="auto">
                    <b-button variant="mswarning" size="sm" @click="external_facebook.push({key:''})">
                      <b-icon icon="plus-circle" />
                      Add a stream key
                    </b-button>
                  </b-col>
              </b-row>

            </b-popover>

            <b-popover ref="popoverTw" target="quanteecTwitch" triggers="click" placement="top">
              <template #title>
                <b-row class="justify-content-center align-items-center m-2">
                  Stream to Twitch&nbsp; 
                  <font-awesome-icon :class="{quanteectwitchvalide: external_twitch.length > 0}" :icon="['fab', 'twitch']" />
                </b-row>
              </template>

              <b-row class="align-items-center m-1" v-for="(stream,streamid) in external_twitch" v-bind:key="streamid">
                <b-col class="m-0 p-0" cols="11">
                  <b-form-input 
                    size="sm" type="text"
                    v-model="stream.key"
                    :placeholder="'Enter Twitch key '+(streamid+1)">
                  </b-form-input>
                </b-col>
                <b-col class="m-0 p-0" cols="1">
                  <b-button variant="borderedx" v-if="external_twitch.length > 0" size="sm" @click="external_twitch.splice(streamid, 1)">
                    <font-awesome-icon size="sm" style="color:red" icon="times" />
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="justify-content-center mt-3 mb-3">
                  <b-col cols="auto">
                    <b-button variant="msstreamblue" size="sm" @click="$refs['popoverTw'].$emit('close')">
                      Ok
                    </b-button>
                  </b-col>
                  <b-col cols="auto">
                    <b-button variant="mswarning" size="sm" @click="external_twitch.push({key:''})">
                      <b-icon icon="plus-circle" />
                      Add a stream key
                    </b-button>
                  </b-col>
              </b-row>

            </b-popover>

            <b-popover ref="popoverOt" target="quanteecOther" triggers="click" placement="top">
              <template #title>
                <b-row class="justify-content-center align-items-center m-2">
                  Stream to any RTMP server&nbsp; 
                  <font-awesome-icon :class="{quanteecothervalide: external_other.length > 0}" :icon="['fas', 'video']" />
                </b-row>
              </template>

              <b-row class="align-items-center m-1" v-for="(stream,streamid) in external_other" v-bind:key="streamid">
                <b-col  class="m-0 p-0" cols="11">
                  <b-row>
                    <b-col cols="12">
                      <b-form-input 
                        size="sm" type="text"
                        v-model="stream.url"
                        :placeholder="'Enter RTMP url '+(streamid+1)">
                      </b-form-input>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <b-form-input 
                        size="sm" type="text"
                        v-model="stream.key"
                        :placeholder="'Enter RTMP key '+(streamid+1)">
                      </b-form-input>
                    </b-col>

                  </b-row>
                </b-col>
                <b-col class="m-0 p-0" cols="1">
                  <b-button variant="borderedx" v-if="external_other.length > 0" size="sm" @click="external_other.splice(streamid, 1)">
                    <font-awesome-icon size="sm" style="color:red" icon="times" />
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="justify-content-center mt-3 mb-3">
                  <b-col cols="auto">
                    <b-button variant="msstreamblue" size="sm" @click="$refs['popoverOt'].$emit('close')">
                      Ok
                    </b-button>
                  </b-col>
                  <b-col cols="auto">
                    <b-button variant="mswarning" size="sm" @click="external_other.push({url: '', key:''})">
                      <b-icon icon="plus-circle" />
                      Add a stream key
                    </b-button>
                  </b-col>
              </b-row>

            </b-popover>
          </b-row>
          <p style="font-size:11px" v-if="!previewVideo">*Contact QUANTEEC at: support@quanteec.com to simulcast to other platforms</p>

        </b-form-group>

        <div style="border-bottom:1px solid #2a5d77; margin:10px 150px"></div>

        <b-row class="justify-content-center mb-4">
          <b-button size="sm" v-if="!uploadStarted && form.type === 'vod'" class="col-md-3" style="margin:5px" type="submit" variant="msstreamblue" :disabled="files.length === 0">Start</b-button>
          <b-button size="sm" v-if="!uploadStarted && (form.type === 'live' && (urlAuto === 'auto' || urlAuto === 'url'))" class="col-md-3" type="submit" variant="msstreamblue">Start</b-button>
          <b-button size="sm" v-if="!uploadStarted && (form.type === 'live' && urlAuto === 'simple')" class="col-md-5" style="margin:5px" type="submit" variant="msstreamblue">Start Preview</b-button>
        </b-row>
        <b-row v-if="isRequestLoading" class="marginal">
          <div class="col-6"></div>
          <fade-loader color="#00b0ff"></fade-loader>
        </b-row>
      </b-form>

      <div v-if="previewVideo">
        <b-button style="position:absolute; top:2%; right:7px; z-index:2" variant="emptyBWDB" @click="closePreview"> <!-- "showModal('webcamClose');" -->
          <font-awesome-icon icon="times" />
        </b-button>
        <span class="div200" style="color:white; position:absolute; top:1.2%; left:40%; z-index:2">
          {{titleLive}}
        </span>
        <iframe id="video-player" style="width:100%;height:92%;position:absolute;top:54%;left:50%;transform:translate(-50%,-50%);" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameBorder="0" scrolling="no" :src="'/#/captureWindow/' + previewUuid + '?keeplive=' + form.keepLive"></iframe>
      </div>
      <div v-else-if="(form.type==='live')">
        <span class="div200" style="color:white; position:absolute; top:1.2%; left:40%; z-index:2">
          {{form.title}}
        </span>
      </div>
  
  <div v-if="panel === 'simple'">
    <div class="video-container">
      <video class="myVideo" ref="vidView" autoplay muted playsinline></video>
      <div v-if="liveState === 'stopped'" class="liveIndicator">Starting...</div>
      <div v-if="liveState === 'connecting'" class="liveIndicator">Connecting...</div>
      <div v-if="liveState === 'encoding'" class="liveIndicator">Stream starting...</div>
      <div v-if="liveState === 'error'" class="liveIndicator">Error, stream stopped.</div>
      <div v-if="liveState === 'lost'" class="liveIndicator">Connexion lost.</div>
      <div v-if="liveState === 'live'" class="liveIndicator">	&#x1F534; Live</div>
      <b-button v-if="liveState === 'lost' || liveState === 'error'" @click.prevent="startRecording()" class="refreshLive"><font-awesome-icon icon="redo"></font-awesome-icon></b-button>
      <b-button  @click.prevent="stopAll()" class="stopLive"><font-awesome-icon icon="stop"></font-awesome-icon></b-button>

      <b-button  @click.prevent="isFeedback = true" v-if="liveState === 'live' && isFeedback === false" class="feedbackLiveIndicator">Preview</b-button>
      <div class="feedbackContainer" v-if="isFeedback">
        <iframe style="width:100%;height:100%;" class="feedbackIframe" :src="resultIframe"></iframe>
        <b-button  @click.prevent="isFeedback = false" v-if="liveState === 'live'" class="feedbackClose">X</b-button>
      </div>
    </div>
  </div>

  <b-modal ref="webcamClose" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'exclamation-triangle']" />
        Running live
      </h4>
    </div>
    <p style="line-height:normal">
      A live through webcam may be currently running on this window.
      <br />Please confirm the closing. Your live will automatically be stopped, if running. 
    </p>

    <b-row class="justify-content-around">
      <b-button class="col-md-3 col-5" @click="hideModal('webcamClose'); closePreview()" variant="mswarning">
        <font-awesome-icon icon="check" />
        Validate
      </b-button>
      <b-button class="col-md-3 col-5" @click="hideModal('webcamClose')" variant="quanteeclg">
        <font-awesome-icon style="color:red" icon="times" />
        Cancel
      </b-button>
    </b-row>
  </b-modal>

  <b-modal ref="myModalRef" hide-footer hide-header>
    <div class="d-block text-center">
      <h3>Error</h3>
    </div>
    <ul>
    <li v-for="(error, index) in errors" v-bind:key="index" >
        <p>{{error}}</p>
    </li>
    </ul>
    <b-btn class="md-3" variant="green" block @click="hideModal('myModalRef')">OK</b-btn>
  </b-modal>

  <b-modal ref="errorFreeTier" hide-footer hide-header>
    <div class="d-block text-center">
      <h3>Error</h3>
    </div>
    <div class="marginal">
      Free-tier clients are restricted to 1TB of streaming. Please upgrade your plan or delete a video.
    </div>
    <b-btn class="md-3" variant="green" block @click="hideModal('errorFreeTier')">OK</b-btn>
  </b-modal>

  <b-modal 
    id="qualities"
    ref="qualities"
    title="Qualities configuration"
    @show="loadQualitiesModal"
    @hidden="resetModal"
    @cancel="resetModal"
    no-close-on-backdrop
    hide-footer
  >
    <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
      <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
        <h5 style="margin:0px">Qualities encoding method</h5>
      </b-card-header>
      <div>
        <b-form-group label="" v-slot="{ ariaDescribedby }">
          <b-form-radio-group v-model="qualitiesSelection" style="padding:20px 0px 0px 0px">
          
            <b-row class="ml-5 align-items-center">
              <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="default">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />&nbsp;
                <strong style="color:#2a5d77">QUANTEEC</strong> algorithm <small>(default)</small>
              </b-form-radio>
            </b-row>

            <b-form-checkbox size="sm" style="text-align:center" v-if="qualitiesSelection === 'default'" v-model="firstPass" > 
              <span id="popover1">Passthrough-first </span>
              <b-popover size="sm" target="popover1" triggers="hover" placement="top">
                <template #title ><small>Passthrough-first</small></template>
                <small>
                  Make the video immediately available to viewers in passthrough while the encoding is being performed (which will last - at minimum - the duration of the video). 
                  <br />Once finalised, the encoded versions will automatically replace the passthrough one. 
                </small>
              </b-popover>
            </b-form-checkbox>

            <b-row class="ml-5 align-items-center mt-3">
              <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="qualities">
                Custom qualities <small v-if="qualitiesSelection === 'qualities'">(configure below)</small>
              </b-form-radio>
            </b-row>

            <b-form-checkbox size="sm" style="text-align:center" v-if="qualitiesSelection === 'qualities'" v-model="firstPass" > 
              <span id="popover2">Passthrough-first </span>
              <b-popover size="sm" target="popover2" triggers="hover" placement="top">
                <template #title ><small>Passthrough-first</small></template>
                <small>
                  Make the video immediately available to viewers in passthrough while the encoding is being performed (which will last - at minimum - the duration of the video). 
                  <br />Once finalised, the encoded versions will automatically replace the passthrough one. 
                </small>
              </b-popover>
            </b-form-checkbox>

            <b-row class="ml-5 align-items-center mt-3">
              <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="passthrough">
                Passthrough <small>(same as original, no additional quality)</small>
              </b-form-radio>
            </b-row>

          </b-form-radio-group>
        </b-form-group>
      </div>

      <div v-if="qualitiesSelection==='qualities'">
        <div style="border-top:1px solid #2a5d77; margin:10px 30px 20px 30px"></div>
        <b-row class="justify-content-center align-items-center mb-2">
          <h6>Add a quality and adjust your parameters*</h6>
        </b-row>
        
        <b-table centered responsive striped bordered :items="qualitiesModal" :fields="qualitiesTable">
          <template v-slot:cell(bitrate)="row">
            <b-form-input size="sm" style="max-width:120px" v-model="row.item.bitrate" />
          </template>

          <template v-slot:cell(resolution)="row">
            <b-form-select size="sm" v-model="row.item.resolution" :options="resolutions"></b-form-select>
          </template>

          <template v-slot:cell(actions)="row">
            <b-button size="sm" variant="quanteec" @click="removeQuality(row.index)">
              <font-awesome-icon icon="trash" />
            </b-button>
          </template>
        </b-table>

        <b-row class="justify-content-center align-items-center mb-3">
          <b-button size="sm" variant="msstreamblue" @click="addQuality()">
            <b-icon icon="plus-circle" />
            Add a quality to encode
          </b-button>
        </b-row>
        <div style="padding:5px"><small>*For very specific encoding parameters, please contact QUANTEEC at: support@quanteec.com</small></div>  
      </div>

    </b-card>

    <b-row style="margin-top:15px">
      <div class="col-md-2"></div>
      <b-button class="col-md-3" @click="registerQualities(); hideModal('qualities')" variant="mswarning">
        <font-awesome-icon icon="check" />
        Validate
      </b-button>
      <div class="col-md-2"></div>
      <b-button class="col-md-3" @click="resetModal(); hideModal('qualities')" variant="quanteeclg">
        <font-awesome-icon style="color:red" icon="times" />
        Cancel
      </b-button>
    </b-row>

  </b-modal>

  <b-modal 
    id="qualitiesLive"
    ref="qualitiesLive"
    title="Qualities configuration"
    @show="loadQualitiesModalLive"
    @hidden="resetModalLive"
    @cancel="resetModalLive"
    no-close-on-backdrop
    hide-footer
  >
    <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
      <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
        <h5 style="margin:0px">Qualities encoding method</h5>
      </b-card-header>
      <div>
        <b-form-group label="" v-slot="{ ariaDescribedby }">
          <b-form-radio-group v-model="qualitiesSelection" style="padding:20px 0px 0px 0px">

            <b-row class="ml-5 align-items-center">
              <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="default">
                <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:20px" />&nbsp;
                <strong style="color:#2a5d77">QUANTEEC</strong> algorithm <small>(by default)</small>
              </b-form-radio>
            </b-row>

            <b-row class="ml-5 align-items-center mt-3">
              <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="qualities">
                Custom qualities <small v-if="qualitiesSelection === 'qualities'">(configure below)</small>
              </b-form-radio>
            </b-row>

            <b-row class="ml-5 align-items-center mt-3">
              <b-form-radio v-model="qualitiesSelection" :aria-describedby="ariaDescribedby" name="some-radios" value="passthrough">
                Passthrough <small>(same as original, no additional quality)</small>
              </b-form-radio>
            </b-row>

          </b-form-radio-group>
        </b-form-group>
      </div>

      <div v-if="qualitiesSelection==='qualities'">
        <div style="border-top:1px solid #2a5d77; margin:10px 30px 20px 30px"></div>
        <b-row class="justify-content-center align-items-center mb-2">
          <h6>Add a quality and adjust your parameters*</h6>
        </b-row>
        
        <b-table centered responsive striped bordered :items="qualitiesModalLiveTMP" :fields="qualitiesTable">
          <template v-slot:cell(bitrate)="row">
            <b-form-input size="sm" style="max-width:120px" v-model="row.item.bitrate" />
          </template>

          <template v-slot:cell(resolution)="row">
            <b-form-select size="sm" v-model="row.item.resolution" :options="resolutions"></b-form-select>
          </template>

          <template v-slot:cell(actions)="row">
            <b-button size="sm" variant="quanteec" @click="removeQualityLive(row.index)">
              <font-awesome-icon icon="trash" />
            </b-button>
          </template>
        </b-table>

        <b-row class="justify-content-center align-items-center mb-3">
          <b-button size="sm" variant="msstreamblue" @click="addQualityLive()">
            <b-icon icon="plus-circle" />
            Add a quality to encode
          </b-button>
        </b-row>
        <div style="padding:5px"><small>*For very specific encoding parameters, please contact QUANTEEC at: support@quanteec.com</small></div>  
      </div>
    </b-card>

    <b-row style="margin-top:15px">
      <div class="col-md-2"></div>
      <b-button class="col-md-3" @click="registerQualitiesLive(); hideModal('qualitiesLive')" variant="mswarning">
        <font-awesome-icon icon="check" />
        Validate
      </b-button>
      <div class="col-md-2"></div>
      <b-button class="col-md-3" @click="resetModalLive(); hideModal('qualitiesLive')" variant="quanteeclg">
        <font-awesome-icon style="color:red" icon="times" />
        Cancel
      </b-button>
    </b-row>

  </b-modal>

  <b-modal
    id="liveCreated"
    ref="liveCreated"
    title="Live creation: success"
    no-close-on-backdrop
    hide-header hide-footer>
  
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-layers style="margin-right:5px">
          <font-awesome-icon size="sm" style="color: #ba0000" icon="video" />
          <font-awesome-icon size="sm" style="color: #ba0000" icon="circle-notch" transform="shrink-3 left-14" spin />
        </font-awesome-layers>
        Live creation: success
      </h4>
    </div>

    <p style="line-height:normal">
      Live stream: 
      <b-button variant="emptyB" @click="openLivePage(newLiveUUID);closeWindowAfterLiveCreation();hideModal('liveCreated')" title="Click to open related page">
        <strong>{{tampTitle}}</strong>&nbsp;
        <font-awesome-icon icon="external-link-alt" />
      </b-button>
      has been successfully created.
      <br />Go directly on its dedicated page by
      <i @click="openLivePage(newLiveUUID);closeWindowAfterLiveCreation();hideModal('liveFinishWebcam')" style="cursor:pointer">clicking here</i> (or on the title above). 
      <br />
      <br />If you have selected the option to automatically save your live stream into VOD files, the archives will be automatically processed each time you stop the stream or when the stream will not receive inputs for 1min.

    </p>

    <b-row class="justify-content-around">
      <b-btn class="col-5" variant="msstreamblue" @click="hideModal('liveCreated')" >
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'video']" />
        Create another live
      </b-btn>
      <b-btn class="col-5" variant="quanteeclg" @click="closeWindowAfterLiveCreation(); hideModal('liveCreated')" >
        <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
        Close
      </b-btn>
    </b-row>

  </b-modal>

  <b-modal
    id="liveFinishWebcam"
    ref="liveFinishWebcam"
    title="Your live webcam is finished"
    no-close-on-backdrop
    hide-footer hide-header>
  
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-layers style="margin-right:5px">
          <font-awesome-icon size="sm" style="color: #ba0000" icon="video" />
          <font-awesome-icon size="sm" style="color: #ba0000" icon="circle-notch" transform="shrink-3 left-14" spin />
        </font-awesome-layers>
        Webcam Live: finished
      </h4>
    </div>

    <p style="line-height:normal">
      Webcam Live stream: 
      <b-button variant="emptyB" @click="openLivePage(newLiveUUID);closeWindowAfterLiveCreation();hideModal('liveFinishWebcam')" title="Click to open related page">
        <strong>{{titleLive}}</strong>&nbsp;
        <font-awesome-icon icon="external-link-alt" />
      </b-button>
      has been successfully finalised. You can restart it on its dedicated page 
      <i @click="openLivePage(newLiveUUID);closeWindowAfterLiveCreation();hideModal('liveFinishWebcam')" style="cursor:pointer">(click here or on title).</i> 
      <br />
      <br />If you have selected the option to automatically save your live stream into VOD files, the archive is being processed and will soon be available.
    </p>

    <b-row class="justify-content-around">
      <b-btn class="col-5" variant="msstreamblue" @click="hideModal('liveFinishWebcam')" >
        <font-awesome-icon style="margin-right:5px" :icon="['fas', 'video']" />
        Create another live
      </b-btn>
      <b-btn class="col-5" variant="quanteeclg" @click="closeWindowAfterLiveCreation(); hideModal('liveFinishWebcam')" >
        <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
        Close
      </b-btn>
    </b-row>

    <!--
    <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">
      <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
        <h5 style="margin:0px">Webcam live finished</h5>
      </b-card-header>
      <div>
        <b-row class="justify-content-center align-items-center mb-2">
          Your live with webcam has been terminated with success.
        </b-row>
        <b-row class="justify-content-center align-items-center mb-2">
          <b-button class="col-md-3" @click="openLivePage(newLiveUUID);closeWindowAfterLiveCreation();hideModal('liveFinishWebcam')" variant="mswarning">
            See my live
          </b-button>
        </b-row>
      </div>
    </b-card>
    <b-row style="margin-top:15px">
      <div class="col-md-2"></div>
      <b-button class="col-md-3" @click="hideModal('liveFinishWebcam')" variant="mswarning">
        <font-awesome-icon icon="check" />
        Create another live
      </b-button>
      <div class="col-md-2"></div>
      <b-button class="col-md-3" @click="closeWindowAfterLiveCreation(); hideModal('liveFinishWebcam')" variant="quanteeclg">
        <font-awesome-icon style="color:red" icon="times" />
        Close creation live window
      </b-button>
    </b-row>
    -->
  </b-modal>
  <b-modal ref="confirmCopyClipAddr" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="margin-right:5px" :icon="['fab', 'affiliatetheme']" />
        Stream URL copied 
      </h4>
    </div>
    <p style="line-height: normal">
      Stream URL:
      <span style="color: #2f90b0">{{autoUrl}}</span> is copied to
      Clipboard.
    </p>
  </b-modal>
  <b-modal ref="confirmCopyClipKey" hide-footer hide-header>
    <div class="d-block text-center">
      <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
        <font-awesome-icon style="margin-right:5px" :icon="['fab', 'affiliatetheme']" />
        Stream Key copied 
      </h4>
    </div>
    <p style="line-height: normal">
      Stream Key:
      <span style="color: #2f90b0">{{autoID}}</span> is copied to
      Clipboard.
    </p>
  </b-modal>


</div>
</template>
  
<script>
import { EventBus } from '@/event-bus.js';
import FadeLoader from 'vue-spinner/src/FadeLoader.vue'
import VideoService from '@/services/video.service';

import {BASE_URL, EMBED_URL, BASE_RTC, RTMP_URL} from '@/services/base-url';
import {v4 as uuidv4} from 'uuid';
var videoService = new VideoService();
var autoID_init = uuidv4().split("-").join('');
export default {
  name: 'VodForm',
  components: {
    'FadeLoader': FadeLoader,
  },
  props: [
    'componentType',
    'specificVideoID'
  ],
  data: function() {
    return {
      //LIVE
      isShowKey: false,
      titleLive:'',
      tampTitle:'',
      liveToKeepDuration: 30,
      device: null,
      ws: null,
      mediaRecorder: undefined,
      streamStarted: false,
      mediaStreamObj: undefined,
      newmediaRecorder: undefined,
      newmediaStreamObj: undefined,
      newRecorderCreated: false,
      intervalKey: undefined,
      intervalCheckVideoLive: undefined,
      selectedVideoDevice: undefined,
      selectedAudioDevice: undefined,
      videoDeviceList: [],
      audioDeviceList: [],
      isPreviewMuted: true,
      liveState: "stopped",
      quanteecVideo: undefined,
      resultIframe: '',
      isFeedback: false,
      sendTransport: undefined,
      transportCallbacks: {
        connect: {},
        produce: {}
      },
      producerVideo: null,
      producerAudio: null,
      videosUploading : [],

      //OTHER
      panel: 'creation', // 'simple', 'creation'
      externalStreams: [],
      externalOptions: [
        {
          text: "Youtube",
          value: "youtube"
        },
        {
          text: "Facebook",
          value: "facebook"
        },
        {
          text: "Twitch",
          value: "twitch"
        },
        {
          text: "Other",
          value: "other"
        }
      ],
      isMoreOptions: false,
      isDraghover: false,
      uploadStarted: false,
      autoID: autoID_init,
      autoUrl: RTMP_URL,
      urlAuto: 'simple',//'auto',
      isPassword: false,
      myPassword: '',
      passwordType: 'password',
      form: {
        title: 'Live_' + autoID_init,
        type: 'live',
        url: '',
        keepLive: (this.$auth.getMyUser().client_infos[0].noKeepLive) ? false : true,
        stream: false,
        seekLive: true,
        delay: 'middle',
        autoplay: (this.$auth.getMyUser().client_infos[0].defaultAutoplay === false) ? false : true,
      },
      fileOrUrl:'file',
      encodingOptions: [
        {
          value: "encoding",
          text: "encoding"
        }, {
          value: "passthrough",
          text: "passthrough"
        }
      ],
      audioOptions: [
        {
          value: "false",
          text: "false"
        }, {
          value: "true",
          text: "true"
        }
      ],
      file: null,
      files: [],
      categoryOptions: [],
      errors: [],
      isRequestLoading: false,
      previewVideo: false,
      previewUuid : false,
      external_youtube: [],
      external_facebook: [],
      external_twitch: [],
      external_other: [],

      selectedFile:"",
      qualitiesSelection:"default",
      qualitiesModal:[],
      qualitiesModalLive:[],
      qualitiesModalLiveTMP:[],
      encodingLive:"encoding",
      qualitiesTable : 
        [
            { key: "bitrate", label: "Bitrate (kbps)", thClass: 'text-center', tdClass: 'text-center'},
            { key:"resolution", label :"Resolution", thClass: 'text-center', tdClass: 'text-center'},
            { key: "actions", label: "Action(s)", thClass: 'text-center', tdClass: 'text-center'}
        ],
      resolutions:[
        {
          value:
          {
            width:256,
            height:144
          },
          text:"YouTube 144p: 256x144"
        },
        {
          value:
          {
            width:384,
            height:576
          },
          text:"SECAM: 384x576"
        },
        {
          value:
          {
            width:450,
            height:576
          },
          text:"PAL: 450x576"
        },
        {
          value:
          {
            width:323,
            height:486
          },
          text:"NTSC: 323x486"
        },
        {
          value:
          {
            width:352,
            height:288
          },
          text:"MPEG-1 PAL: 352x288"
        },
        {
          value:
          {
            width:352,
            height:243
          },
          text:"MPEG-1 NTSC: 352x243"
        },
        {
          value:
          {
            width:720,
            height:576
          },
          text:"MPEG-2 PAL: 720x576"
        },
        {
          value:
          {
            width:480,
            height:576
          },
          text:"MPEG-2 PAL: 720x480"
        },
        {
          value:
          {
            width:1280,
            height:720
          },
          text:"HD: 1280x720"
        },
        {
          value:
          {
            width:1920,
            height:1080
          },
          text:"Full HD: 1920x1080"
        },
        {
          value:
          {
            width:3840,
            height:2160
          },
          text:"UHD (4K): 3840x2160"
        },        
        {
          value:
          {
            width:7680,
            height:4320
          },
          text:"UHD (8K): 7680x4320"
        },
          
      ],
      qualitiesTmp : {},
      firstPass:false,
    }
  }, 
  beforeDestroy() {
    try {
      clearInterval(this.intervalKey);
    } catch(e) {}
    try {
      clearInterval(this.intervalCheckVideoLive);
    } catch(e) {}
    try {
      this.stopPreview()
    } catch(e) {}
    try {
      this.ws.close();
    } catch(err) {}
  },
  mounted(){
    let self = this;
    window.addEventListener('message', (e) => {
      if (e.origin !== window.origin) {
        return;
      }
      let data = e.data;
      if (data === 'closePreview') {
        self.closePreview();
      }
      if (data === 'videoListRefresh') {
        EventBus.$emit('VideoListRefresh');
      }
      if (data === "getLiveInput") {
          let response = {
            isPassword: self.isPassword,
            password: self.myPassword,
            keepLive: self.form.keepLive,
            delay: self.form.delay,
            external_youtube: self.external_youtube,
            external_facebook: self.external_facebook,
            external_twitch: self.external_twitch
          }
          e.source.postMessage(JSON.stringify(response), window.origin);
      }

    });
    if (this.$route.params["videoType"]) {
      this.form.type = this.$route.params["videoType"];
    } else if (this.componentType) {
      this.form.type = this.componentType;
    }

    if (this.$route.params["specificVideoID"]) {
      this.autoSubmitVideo(this.$route.params["specificVideoID"]);
    } else if (this.specificVideoID) {
      this.autoSubmitVideo(this.specificVideoID);
    }

    
  }, 
  methods: {
    removeQualityLive(idx)
    {
      this.qualitiesModalLiveTMP.splice(idx,1)
    },
    loadQualitiesModalLive()
    {
      if(this.qualitiesModalLive.length > 0)
        this.qualitiesSelection="qualities"
      else if(this.encodingLive === "passthrough")
        this.qualitiesSelection="passthrough"
      else 
        this.qualitiesSelection = "default"

      this.qualitiesModalLiveTMP = JSON.parse(JSON.stringify(this.qualitiesModalLive));

    },
    registerQualitiesLive()
    {
      this.qualitiesModalLive = [];
      if(this.qualitiesSelection === "qualities")
        this.qualitiesModalLiveTMP.forEach(quality =>{
          this.qualitiesModalLive.push(quality);
        })

      if(this.qualitiesSelection === "passthrough")
      {
        this.encodingLive = "passthrough"
      }
      else{
        this.encodingLive = "encoding"
      }
    },
    resetModalLive(){
      this.qualitiesModalLiveTMP = [];
      this.qualitiesSelection="default";
    },
    addQualityLive()
    {
      var newQuality = {
          bitrate : 5000,
          resolution:{
              height: 1080,
              width: 1920,
          },
          FPS:30,
      }
      this.qualitiesModalLiveTMP.push(newQuality)
    },
    removeQuality(idx)
    {
      this.qualitiesModal.splice(idx,1)
    },
    loadQualitiesModal()
    {
      if(this.selectedFile.qualities.length > 0)
        this.qualitiesSelection="qualities"
      else if(this.selectedFile.encoding === "passthrough")
        this.qualitiesSelection="passthrough"
      else 
        this.qualitiesSelection = "default"

      this.qualitiesModal = JSON.parse(JSON.stringify(this.selectedFile.qualities));
      this.firstPass = this.selectedFile.firstPass;

    },
    registerQualities()
    {
      this.selectedFile.qualities = [];
      if(this.qualitiesSelection === "qualities")
        this.qualitiesModal.forEach(quality =>{
          this.selectedFile.qualities.push(quality);
        })

      if(this.qualitiesSelection === "passthrough")
      {
        this.selectedFile.encoding = "passthrough"
      }
      else {
        this.selectedFile.encoding = "encoding"
      }

      this.selectedFile.firstPass = this.firstPass
      this.files.splice(0,0)
    },
    copyClipAddr() {
      this.$copyText(this.autoUrl);
    },
    copyClipKey() {
      this.$copyText(this.autoID);
    },
    showAndHideModal(ref) {
      let self = this;
      self.showModal(ref);
      setTimeout(function () {
        self.hideModal(ref);
      }, 3000);
    },
    resetModal(){
      this.selectedFile = "";
      this.qualitiesModal = [];
      this.qualitiesSelection="default";
      this.firstPass = false;
    },
    addQuality()
    {
      var newQuality = {
          bitrate : 5000,
          resolution:{
              height: 1080,
              width: 1920,
          },
          FPS:30,
      }
      this.qualitiesModal.push(newQuality)
    },
    refreshTitle() {
      this.autoID = uuidv4().split("-").join('');
      this.form.title = 'Live_' + this.autoID;
    },
    closePreview()
    {
      this.previewVideo = false;
      videoService.deleteVideoIfUploading(this.newLiveUUID, this.$auth.token())
      .then((response) => {
        if (response.uuid) {
          this.showModal("liveFinishWebcam")
        } else {
          this.closeWindowAfterLiveCreation()
        }
      }).catch(err => {
        this.showModal("liveFinishWebcam")
      })
      
    },
    goCapture() {
      EventBus.$emit("closeCurrentWindow");
      this.$router.push('/capture?title=' + encodeURI(this.form.title));
    },
    goCaptureUuid(uuid) {
      EventBus.$emit("closeCurrentWindow");
      this.$router.push('/capture/' + uuid);
    },
    stopAll() {
      if (this.quanteecVideo && this.quanteecVideo.uuid) {
        this.$router.push('/player/' + this.quanteecVideo.uuid);
      } else {
        this.$router.push('/');
      }
    },
    checkVideo() {
      let self = this;
      videoService.getVideoById(this.quanteecVideo.uuid, this.$auth.token()).then((video) => {
        self.quanteecVideo = video;
        if (video.encodingStatus === "encoding") {
          self.liveState = "live";
        }
        if (['encoded', 'error', 'stopped'].indexOf(video.encodingStatus) > -1) {
          self.liveState = "error";
        }
      }).catch((err) => {
        self.liveState = "error";
      })
    },
    goToCapture() {
      EventBus.$emit("closeCurrentWindow");
      window.location.href = "https://test.quanteec.com/capture";
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    cancelUpload(index)
    {
        this.files[index].toCancel = true;      
    },
    addFile(e) {
      let droppedFiles = (e.dataTransfer)? e.dataTransfer.files : e.target.files;
      if(!droppedFiles) return;
      ([...droppedFiles]).forEach(f => {
        if (f.type.match("video") || f.type.match("mxf")) {
          //La ligne en dessous ne fonctionne pas/plus
          if(this.files.findIndex(file => file.name === f.name) === -1)
          {
            f.toCancel = false;
            f.qualities = [];
            f.encoding = "encoding";
            this.files.push(f);
          }
            
        }

      });
    },
    uploadFiles(results) {
      var chunkSize = 5 * 1000000;
      this.uploadstarted = true;
      function slice(file, start, end) {
        var slice = file.mozSlice ? file.mozSlice :
                    file.webkitSlice ? file.webkitSlice :
                    file.slice ? file.slice : noop;
        
        return slice.bind(file)(start, end);
      }

      var uploadFile = (video, fileIndex) => {        
        let seconds_to_days_hours_mins_secs_str =function(seconds) { 
          var hours    = Math.floor(seconds / (60*60));
              seconds -= hours   * (60*60);
          var minutes  = Math.floor(seconds / (60));
              seconds -= minutes * (60);
          if (minutes < 10 && hours > 0) {
              minutes = "0" + minutes;
          }
          if ((minutes > 0 || hours > 0) && seconds < 10) {
              seconds = "0" + seconds;
          }
          
          return ((0<hours)?(hours+":"):"") + ((0<minutes || hours > 0)?(minutes+":"):"") +seconds+"s";
        }

        return new Promise((done, reject) => {
          self = this;
          self.files[fileIndex].isLoading = true;
          self.files[fileIndex].isLoadingEnd = false;
          self.files[fileIndex].isLoadingError = false;
          self.files[fileIndex].loadingPercent =  0;
          self.files[fileIndex].currentChunk =  1;
          self.files[fileIndex].currentData =  0;
          self.files[fileIndex].startDate =  new Date();
          self.files = self.files.splice(0, self.files.length);

          var sendNextData = function() {
            var start = self.files[fileIndex].currentData;
            var fixedStart = start;
            var size = self.files[fileIndex].size;
            var end = start + chunkSize;
            var isEnd = false;
            
            if (size - end <= 0) {
              end = size;
              isEnd= true;
            }

            var data = slice(self.files[fileIndex], start, end);
            videoService.postChunk(video.video.uuid, self.files[fileIndex].currentChunk, data, video.video.title, isEnd, self.$auth.token()).then(() => {
              if (isEnd) {
                self.files[fileIndex].isLoading = false;
                self.files[fileIndex].isLoadingError = false;
                self.files[fileIndex].isLoadingEnd = true;
                self.files[fileIndex].loadingPercent =  100;
                videoService.putVideoById({uploadingPercent: 100, uploadingETA: '0s', lastUploadingFeedbackDate: new Date()}, video.video.uuid, self.$auth.token()).then(() =>{}).catch(err => {});
                self.files = self.files.splice(0, self.files.length);
                done();
              } else {
                var start = self.files[fileIndex].currentData += chunkSize;
                self.files[fileIndex].currentChunk += 1
                self.files[fileIndex].loadingPercent =  Math.round(100 * self.files[fileIndex].currentData / self.files[fileIndex].size);

                let currentDate = new Date();
                let currentPercent = self.files[fileIndex].loadingPercent;
                let timeSpentMS = currentDate.getTime() - self.files[fileIndex].startDate.getTime();
                let estimatedEndDuration = Math.round(timeSpentMS * 100 / currentPercent);
                let estimatedEndDate = new Date(self.files[fileIndex].startDate.getTime() + estimatedEndDuration);
                let durationUntilEnd = seconds_to_days_hours_mins_secs_str(Math.round((estimatedEndDate.getTime() - currentDate.getTime()) / 1000))
                videoService.putVideoById({uploadingPercent: self.files[fileIndex].loadingPercent, uploadingETA: durationUntilEnd, lastUploadingFeedbackDate: currentDate, currentChunk: self.files[fileIndex].currentChunk}, video.video.uuid, self.$auth.token()).then(() =>{}).catch(err => {});
                
                self.files = self.files.splice(0, self.files.length);
                
                if(!self.files[fileIndex].toCancel)
                  setTimeout(sendNextData, 1);
                else{
                  
                  self.files[fileIndex].isLoading = false;
                  self.files[fileIndex].isLoadingError = false;
                  self.files[fileIndex].isLoadingEnd = true;
                  done();
                }
              }

            }).catch((err) => {
                self.files[fileIndex].isLoading = false;
                self.files[fileIndex].isLoadingEnd = false;
                self.files[fileIndex].isLoadingError = true;
                self.files[fileIndex].loadingPercent =  0;
                self.files = self.files.splice(0, self.files.length);

                done()
            })
          }

          if(!self.files[fileIndex].toCancel)
            sendNextData();
          else{
                  self.files[fileIndex].isLoading = false;
                  self.files[fileIndex].isLoadingError = false;
                  self.files[fileIndex].isLoadingEnd = true;
                  done();     
          }
        })
      }
      var video = results[0];
      var fileIndex = this.files.findIndex((elem) => {return elem.name === video.video.originalname});

      uploadFile(video, fileIndex).then(() => {
        results.shift();
        if(this.files[fileIndex].toCancel)
        {
          this.removeFile(fileIndex)
                  videoService.deleteVideoById(video.video.uuid, this.$auth.token())
                  .then(()=>{
                    EventBus.$emit('VideoListRefresh');
                  }).catch(err=>
                  {
                    console.log(err);
                  })             
        }
        if (results.length > 0) {
          this.uploadFiles(results);
        } else {
          this.files = [];
          this.uploadStarted = false;
          //document.location.href = document.location.href.split('?uploading=true')[0];
          EventBus.$emit("allowCloseWindow", "New Video(s)");
          this.$router.push('/');
        }
      }).catch((err) => {
        EventBus.$emit("allowCloseWindow", "New Video(s)");
        console.log(err);
      })
    },
    listDevices() {
      return new Promise((done, reject) => {
        let self = this;
        navigator.mediaDevices.enumerateDevices().then(function (devices) {
          self.videoDeviceList = [];
          self.audioDeviceList = [];
          devices.forEach(function (device) {
            if (device.kind === "videoinput") {
              self.videoDeviceList.push({device: device, value: device.label, text: device.label})
              if (self.selectedVideoDevice === undefined) {
                self.selectedVideoDevice = device.label;
              }
            } else if (device.kind === "audioinput") {
              self.audioDeviceList.push({device: device, value: device.label, text: device.label})
              if (self.selectedAudioDevice === undefined) {
                self.selectedAudioDevice = device.label;
              }
            }
          });
          done();
        }).catch(function (err) {
          console.log(err.name, err.message);
          reject();
        });
      });
    },
    affectStreamToVid(str, vid) {
			if ("srcObject" in vid) {
				vid.srcObject = str;
			} else {
				vid.src = window.URL.createObjectURL(str);
			}
    },
    resetPassword() {
      this.isPassword = false;
      this.passwordType = "password";
      this.myPassword = "";
    },
    autoSubmitVideo(uuid) {
      videoService.getVideoById(uuid, this.$auth.token()).then((video) => {
          this.newLiveUUID = video.uuid;
          let currentDate = new Date();
          this.previewVideo = true;

          this.previewUuid = video.uuid;
          this.form.title = video.title;
          this.form.type = video.type;
          this.titleLive = video.title;

          this.isPassword = video.isPassword;
          this.myPassword = video.myPassword;
          this.form.keepLive = video.keepLive;
          this.form.delay = video.directStream || "middle";
          this.external_youtube = [];
          this.external_facebook = [];
          this.external_twitch = [];


          this.refreshTitle();
      }).catch(err => {

      })
    },
    onSubmit: function() {
      if (this.form.type === "vod" && this.fileOrUrl === 'file') {

        var videos = [];
        for (var file of this.files) {
          var data = {
            type: "vod", 
            title: file.name, 
            uploadingPercent: 0,
            }
          if(file.qualities.length > 0)
            data.inputQualities = file.qualities

          if(file.encoding === "passthrough")
          {
            data.encoding = "passthrough"
          }

          data.firstPass = file.firstPass;
          data.autoplay = this.form.autoplay;

          videos.push(data);
        }
        videoService.postVideos(videos, this.$auth.token()).then((result) => {

          this.uploadStarted = true;
          //document.location.href = document.location.href + '?uploading=true';
          this.videosUploading = result;
          this.uploadFiles(this.videosUploading);

          EventBus.$emit('VideoListRefresh');
          EventBus.$emit('preventCloseWindow', "New Video(s)");
          this.refreshTitle()
        }).catch((err) => {
          console.log(err)
          if (err.response && err.response.status === 403) {
            this.showModal('errorFreeTier');
          } else {
            this.errors = [];
            this.errors.push("Can not create video");
            this.showModal('myModalRef');
          }
        })
      } else if (this.form.type === "live" && this.urlAuto === "simple") {

        this.titleLive = this.form.title;
        let externalStreams = {youtube: [], facebook: [], twitch: [], other: []};
        if (this.external_youtube.length > 0 && this.external_youtube.filter(x => !!x.key).length > 0) {
          externalStreams.youtube = this.external_youtube.filter(x => !!x.key);
        }
        if (this.external_twitch.length > 0 && this.external_twitch.filter(x => !!x.key).length > 0) {
          externalStreams.twitch = this.external_twitch.filter(x => !!x.key);
        }
        if (this.external_facebook.length > 0 && this.external_facebook.filter(x => !!x.key).length > 0) {
          externalStreams.facebook = this.external_facebook.filter(x => !!x.key);
        }
        if (this.external_other.length > 0 && this.external_other.filter(x => !!x.key && !!x.url).length > 0) {
          externalStreams.other = this.external_other.filter(x => !!x.key && !!x.url);
        }

        videoService.postVideoJson({
          title: this.form.title,
          "type": "live",
          "keepLive": this.form.keepLive,
          "seekLive": this.form.seekLive,
          "url": `Quanteec`,
          "encodingStatus": "uploading",
          "canResume": true,
          'isPassword': this.isPassword,
          "password": this.myPassword,
          "externalStreams": externalStreams,
          "encoding": this.encodingLive,
          "inputQualities": (this.qualitiesModalLive.length > 0) ? this.qualitiesModalLive : "QuanteecOptimization",
          "autoplay": this.form.autoplay,
          "directStream": this.form.delay,
          "liveType": 'camera'
          }, this.$auth.token()
        ).then((video) => {
          this.newLiveUUID = video.uuid;
          let currentDate = new Date();
          EventBus.$emit('VideoListRefresh');
          this.previewVideo = true;
          

          this.previewUuid = video.uuid;
          this.refreshTitle();

          //this.goCaptureUuid(video.uuid);
        }).catch(err => {
          this.errors = [];
          this.errors.push("Can not create the Live video. Please retry later.");
          this.showModal('myModalRef');
        })
        //this.goCapture();
        //this.panel = "simple";
       
        //setTimeout(this.useDevice,0,this.selectedVideoDevice, this.selectedAudioDevice); //mlacaud
      } else if (this.form.type === "live" && this.urlAuto === "multi") {
        this.panel = "multi";
      } else {
        this.basicPost();
      }
    },
    basicPost: function() {
      if (this.form.type === 'vod' && this.fileOrUrl==='file') {
        var formdata = new FormData();
        formdata.append('title', this.form.title);
        formdata.append('type', this.form.type);
        formdata.append('video', this.file, this.file.name);
        this.isRequestLoading = true;
        videoService.postVideo(formdata, this.$auth.token())
        .then((video) => {
          this.isRequestLoading = false;
          this.$router.replace({path: '/'});
          EventBus.$emit('VideoListRefresh');
          this.refreshTitle()
        }).catch((error) => {
          this.isRequestLoading = false;
          if (error.response && error.response.status === 403) {
            this.showModal('errorFreeTier');
          } else {
            this.errors = [];
            this.errors.push("Can not create video");
            this.showModal('myModalRef');
          }
        })
      } else {
        let data = {
          title: this.form.title,
          type: this.form.type,
          isPassword:this.isPassword,
          password:this.myPassword 
        }
        if(this.form.type === 'vod' && this.fileOrUrl === 'url') {
          data.url = this.form.url
        } else if (this.form.type === 'live') {
          data.keepLive = this.form.keepLive;
          data.seekLive = this.form.seekLive;
          data.autoplay = this.form.autoplay;
          data.encoding = this.encodingLive;
          data.inputQualities = (this.qualitiesModalLive.length > 0) ? this.qualitiesModalLive : "QuanteecOptimization";

          if (!data.keepLive && this.liveToKeepDuration) {
            data.liveToKeepDuration = +this.liveToKeepDuration;
          }
          if (this.urlAuto === "url") {
            data.url = this.form.url;
            data.liveType = "custom";
          } else {
            data.url = this.autoUrl + '/' + this.autoID;
            data.liveType = "quanteecRTMP";
            data.encodingStatus = "stopped";
          }
          let externalStreams = {};
          if (this.external_youtube.length > 0 && this.external_youtube.filter(x => !!x.key).length > 0) {
            externalStreams.youtube = this.external_youtube.filter(x => !!x.key);
          }
          if (this.external_twitch.length > 0 && this.external_twitch.filter(x => !!x.key).length > 0) {
            externalStreams.twitch = this.external_twitch.filter(x => !!x.key);
          }
          if (this.external_facebook.length > 0 && this.external_facebook.filter(x => !!x.key).length > 0) {
            externalStreams.facebook = this.external_facebook.filter(x => !!x.key);
          }
          if (this.external_other.length > 0 && this.external_other.filter(x => !!x.key && !!x.url).length > 0) {
          externalStreams.other = this.external_other.filter(x => !!x.key && !!x.url);
        }

          data.externalStreams = externalStreams;
          
        }
        this.isRequestLoading = true;

        videoService.postVideoJson(data, this.$auth.token())
        .then((video) => {
          this.isRequestLoading = false;
          this.$router.replace({path: '/'});
          EventBus.$emit('VideoListRefresh');
          this.refreshTitle();
          this.tampTitle = video.title;
          this.showModal("liveCreated");
          this.newLiveUUID = video.uuid;
        }).catch((error) => {
          this.isRequestLoading = false;
          if (error.response && error.response.status === 403) {
            this.showModal('errorFreeTier');
          } else {
            this.errors = [];
            this.errors.push("Can not create video");
            this.showModal('myModalRef');
          }
        })

      }
      
    },
    openLivePage(uuid)
    {
      this.$router.push('/player/' + uuid);
    },
    selectedDate(event) {
      this.form.eventDate = event;
    },
    onReset: function() {
      this.form = {
        title: '',
        description: '',
        type: 'vod',
        url: '',
        author: ''
      }
      this.liveToKeepDuration = 120;
      this.files = [];
    },
    onUnchecked(value) {
      this.captureMode = value;
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    createTag(label){
      const div=document.createElement('span')
      div.setAttribute('class','badge badge-secondary badge-pill mr-1')
      const span=document.createElement('span')
      span.innerHTML=label;
      const closeBtn=document.createElement('i')
      closeBtn.setAttribute('class','fas fa-times ml-1')

      div.appendChild(span)
      div.appendChild(closeBtn)
      return div
    },
    addTags(){
      this.reset();
      const self=this
      this.form.tags.slice().reverse().forEach(function(tag){
        const input=self.createTag(tag);
        const tagContainer=document.querySelector('.tag')
        tagContainer.prepend(input);
      })
    },
    reset(){
      document.querySelectorAll('.badge-pill').forEach(function(tag){
        tag.parentElement.removeChild(tag);
      })
    },
    hasPlatform(platform) {
      return (this.externalStreams.findIndex(x => x.platform === platform) > -1)
    },
    addPlatform() {
      let currentPlatform = "other";
      if(!this.hasPlatform("twitch")) {
        currentPlatform = "twitch";
      };
      if(!this.hasPlatform("facebook")) {
        currentPlatform = "facebook";
      };
      if(!this.hasPlatform("youtube")) {
        currentPlatform = "youtube";
      };

      this.externalStreams.push({
        name: this.$auth.getMyUser().clientname + "_stream_" + this.externalStreams.length,
        platform: currentPlatform,
        key: ""
      })
    },
    removeExternalStream(name) {
      let index = this.externalStreams.findIndex(x => x.name === name);
      if (index > -1) {
        this.externalStreams.splice(index, 1);
      }
    },
    EventManagement(){
      var self=this
      const input=document.querySelector('.createTag')
      input.addEventListener('keyup',function(e){
        if(e.key===" "){
          self.form.tags.push(input.value)
          self.addTags()
          input.value='';
        }
      }),
      document.addEventListener('click',function(e){
        if(e.target.className==='fas fa-times ml-1'){
          const value=e.target.previousElementSibling.innerHTML
          const index=self.form.tags.indexOf(value)
          self.form.tags=[...self.form.tags.slice(0,index),...self.form.tags.slice(index+1)]
          self.addTags()
        }
      })
    },
    beforeunloadFn(e)
    {
      var filesNotUpload = []
      this.videosUploading.forEach(video=>
      {
        filesNotUpload.push(video.video.uuid)
      })

      videoService.failedUpload(this.$auth.token(), {uuids:filesNotUpload})
      .catch(err=>{})
    },
    closeWindowAfterLiveCreation()
    {
      EventBus.$emit("closeCurrentWindow");
    }
  },
  created(){
     window.addEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
  destroyed(){
     window.removeEventListener('beforeunload', e => this.beforeunloadFn(e))
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.borderedyt {
  border: 2px solid;
  border-radius: 10px;
  border-color: rgba(#b2071d, 1);
  background-color:  rgba(#b2071d, 0.2);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.borderedfb {
  border: 2px solid;
  border-radius: 10px;
  border-color: rgba(#3b5998, 1);
  background-color:  rgba(#3b5998, 0.2);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.borderedtwitch {
  border: 2px solid;
  border-radius: 10px;
  border-color: rgba(#6441a5, 1);
  background-color:  rgba(#6441a5, 0.2);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.borderedother {
  border: 2px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  background-color:  rgba(grey, 0.2);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.unselectedChoice2 {
  border: 3px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  box-shadow: rgba(#0f182f, 0.117647) 1px 2px 7px, rgba(#0f182f, 0.117647) 1px 2px 7px;
}

.selectedChoice2 {
  border: 3px solid;
  border-radius: 10px;
  //border-color: rgba(#19b952, 1);
  border-color: rgba(#14BF98, 1);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.commonChoice2 {
  text-align: center;
  min-height: 120px;
  font-weight: 400;
  font-size: 1.1rem;
  color:#2a5d77;
  cursor: pointer;
  margin: 10px;
  padding: 5px;
}

.commonChoice3 {
  text-align: center;
  min-height: 70px;
  font-weight: 400;
  font-size: 1.1rem;
  color:#2a5d77;
  cursor: pointer;
  margin: 2px;
  padding: 2px;
}

.unselectedChoice {
  border: 4px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  box-shadow: rgba(#0f182f, 0.117647) 1px 2px 7px, rgba(#0f182f, 0.117647) 1px 2px 7px;
}

.selectedChoice {
  border: 4px solid;
  border-radius: 10px;
  //border-color: rgba(#19b952, 1);
  border-color: rgba(#ba0000, 1);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.commonChoice {
  text-align: center;
  min-height: 60px;
  font-weight: 500;
  font-size: 2rem;
  color:black;
  cursor: pointer;
}

.uploadtext {
  color: rgba(#2a5d77, 1);
  font-style: italic;
  padding: 10px;
  margin: 10px;
  text-align:center;
}

.uploadlogo {
  margin-top: 30px;
  height: 100px; 
  width:100%; 
  color: rgba(#2a5d77, 0.8)
}

.removelogo {
  height: 20px; 
  width: 20px; 
}

.filelogo {
//  margin-top: 6px;
//  height: 100px; 
//  width:100%; 
  margin: 0px 10px;
  height: 30px; 
  width:5%; 
  color: rgba(#2a5d77, 0.8)
}

.draggable {
  min-height: 240px;
  outline: 2px dashed #2a5d77;
  outline-offset: -5px;
  box-shadow: rgba(black, 0.3) 1px 2px 7px, rgba(black, 0.3) 1px 2px 7px;
  background-color: rgba(#2F90B0, 0.03);
  //background-image: radial-gradient(circle at center, rgba(#19b952, 0.01), rgba(#19b952, 0.05));
}

.draggable.draghover {
  outline: 5px dashed #2a5d77;
  background-color: rgba(black, 0.03);
  //background-image: radial-gradient(circle at center, rgba(grey, 0.01), rgba(grey, 0.05)) !important;
}

.tag{
 font: 400 17px system-ui;
 overflow: hidden;
}
.tag input{
  border:none;
  outline:none;
}

.inputCard {
  transform: scale(0.9);
  outline: 3px double #2a5d77; //#ba0000;
  outline-offset: -3px;
  box-shadow: rgba(black, 0.3) 1px 2px 7px, rgba(black, 0.3) 1px 2px 7px;
  background-color: rgba(#2F90B0, 0.07);
  margin: 10px;
  padding: 10px;
  transition: .15s all ease-in-out;
  &:hover {
      box-shadow: rgba(black, 0.3) 1px 2px 7px, rgba(black, 0.3) 1px 2px 7px;
      transform: scale(0.91);
    }
  //background-image: radial-gradient(circle at center, rgba(#19b952, 0.1), rgba(#19b952, 0.2));
}

.previewContainer {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background-color: black;
}

.previewVideo {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.previewMuted {
  position: absolute;
  background:rgba(#000000, 0.9);
	box-shadow: 1px 2px 7px #fff, 1px 2px 7px #fff;
	border-radius: 50%;
  border-style: none;
	color:#fff;
  z-index: 1;
  &:active {
    transform: scale(0.98);
  }
  width: 50px;
  height: 50px;
  top: 2px;
  right: 2px;
  bottom: auto;
  left: auto;

  @media(max-width: 400px) {
    width: 40px;
    height: 40px;
  }
}

.containerCircleLive {
  position: relative;
  width: 100%;
  padding-top:100%;
}

.circleLive {
  position: absolute;
  height: 100%;
  width: 100%;
  -webkit-animation: 2s linear 0s infinite alternate clignote;
  animation: 2s linear 0s infinite alternate clignote;
}

@-webkit-keyframes clignote { 
  0%{background: radial-gradient(#ba0000, rgba(#ba0000,0.5), rgba(#ba0000,0));}
  50%{background: radial-gradient(#ba0000, rgba(#ba0000,0.8), rgba(#ba0000,0.5));}
  100%{background: radial-gradient(#ba0000, rgba(#ba0000,1), rgba(#ba0000,0.8));}
}

@keyframes clignote { 
  0%{background: radial-gradient(#ba0000, rgba(#ba0000,0.5), rgba(#ba0000,0));}
  50%{background: radial-gradient(#ba0000, rgba(#ba0000,0.8), rgba(#ba0000,0.5));}
  100%{background: radial-gradient(#ba0000, rgba(#ba0000,1), rgba(#ba0000,0.8));}
}

.liveIndicator {
  position: absolute;
  background-color:rgba(#000000, 0.9);
	box-shadow: 0px 0px 10px #fff;
	border-radius: 30px;
  padding: 2px 10px;
  border-style: none;
	color:#fff;
  z-index: 1;
  top: 20px;
  left: 10px;
  bottom: auto;
  right: auto;
}

.feedbackLiveIndicator {
  position: absolute;
  background-color:rgba(#000000, 0.9);
	box-shadow: 0px 0px 10px #fff;
	border-radius: 30px;
  padding: 2px 10px;
  border-style: none;
	color:#fff;
  z-index: 1;
  bottom: 20px;
  right: 10px;
  top: auto;
  left: auto;
  &:active {
    transform: scale(0.98);
  }
}

.stopLive {
  position: absolute;
  background:rgba(#000000, 0.9);
	box-shadow: 1px 2px 7px #fff, 1px 2px 7px #fff;
	border-radius: 50%;
  border-style: none;
	color:#ffffff;
  z-index: 2;
  width: 80px;
  height: 80px;
  left: 50%;
  bottom: 0px;
  transform: translate(-50%,-50%);
  font-size:45px;

  @media(max-width: 700px) {
    width: 50px;
    height: 50px;
    font-size: 15px;
  }
}

.refreshLive {
  position: absolute;
  background:rgba(#000000, 0.9);
	box-shadow: 1px 2px 7px #fff, 1px 2px 7px #fff;
	border-radius: 50%;
  border-style: none;
	color:#ffffff;
  z-index: 2;
  width: 80px;
  height: 80px;
  left: 90px;
  bottom: 0px;
  transform: translate(-50%,-50%);
  font-size: 45px;

  @media(max-width: 700px) {
    width: 50px;
    height: 50px;
    font-size: 15px;
  }
}

.feedbackContainer {
  position: fixed;
  bottom: 0px;
  right: 0px;
  top: auto;
  left: auto;
  z-index: 1;
  width: 50vw;
  padding-top: calc(50vw * 0.5625);
  background-color: black;
}

.feedbackIframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.feedbackClose {
  position: absolute;
  background:rgba(#000000, 0.9);
	box-shadow: 1px 2px 7px #fff, 1px 2px 7px #fff;
	border-radius: 50%;
  border-style: none;
	color:#ba0000;
  z-index: 2;
  width: 80px;
  height: 80px;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  font-size:50px;

  @media(max-width: 700px) {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}

.previewVideo {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.video-container {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%; 
  overflow: hidden;
  background-color: black;
}

.myVideo {
  min-width: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  /* Center the video */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.liveBrand {
  text-align: center;
  font-size: 3em;
}

.quanteecyoutubevalide {
   color: #FF0000;
}

.quanteecfacebookvalide {
   color: #4267B2;
}

.quanteectwitchvalide {
   color: #9146FF;
}
.quanteecothervalide {
   color: rgb(20, 191, 152);
}

.quanteecyoutube {
  cursor: pointer;
  transition: .15s all ease-in-out;
  &:hover {
    color: #FF0000;
  }
}

.quanteecfacebook {
  cursor: pointer;
  transition: .15s all ease-in-out;
  &:hover {
    color: #4267B2;
  }
}

.quanteectwitch{
  cursor: pointer;
  transition: .15s all ease-in-out;
  &:hover {
    color: #9146FF;
  }
}

.quanteecother{
  cursor: pointer;
  transition: .15s all ease-in-out;
  &:hover {
    color: rgb(20, 191, 152);
  }
}

.list-devices{
    max-height: 150px;
    overflow-y:scroll;
    -webkit-overflow-scrolling: touch;
}

.borderedyt {
  border: 2px solid;
  border-radius: 10px;
  border-color: rgba(#b2071d, 1);
  background-color:  rgba(#b2071d, 0.2);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.borderedfb {
  border: 2px solid;
  border-radius: 10px;
  border-color: rgba(#3b5998, 1);
  background-color:  rgba(#3b5998, 0.2);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.borderedtwitch {
  border: 2px solid;
  border-radius: 10px;
  border-color: rgba(#6441a5, 1);
  background-color:  rgba(#6441a5, 0.2);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}

.borderedother {
  border: 2px solid;
  border-radius: 10px;
  border-color: rgba(grey, 1);
  background-color:  rgba(grey, 0.2);
  box-shadow: rgba(#0f182f, 0.3) 1px 2px 7px, rgba(#0f182f, 0.3) 1px 2px 7px;
}
</style>